import React from 'react'
import { TextField, VariantType } from '@entur/form'
import { ValidationFormField } from '../../utils/form-utils'
import { validateSsn } from '../../utils/ssn-utils'

export const ssnField = (value?: string): ValidationFormField<string | undefined> => {
  return {
    value: value || '',
    variant: '',
    feedback: '',
    fieldName: 'ssn',
    displayName: 'Personnummer',
    validation: {
      required: false,
    },
  }
}

type TextAndDatePickerProps = {
  dateOfBirthField: ValidationFormField<Date | undefined>
  ssnField: ValidationFormField<string | undefined>
  updateSsn: (value: ValidationFormField<string | undefined>) => void
}
export const SsnFormField: React.FC<TextAndDatePickerProps> = (props) => {
  const validateAndUpdateSsn = () => {
    if (props.dateOfBirthField.value) {
      const validSsn = validateSsn(props.dateOfBirthField.value as Date, props.ssnField.value as string)
      if (!validSsn.valid) {
        props.updateSsn({
          ...props.ssnField,
          variant: 'error',
          feedback: validSsn.message,
        })
      } else {
        props.updateSsn({
          ...props.ssnField,
          variant: '',
          feedback: '',
        })
      }
    }
  }

  return (
    <TextField
      name={props.ssnField.fieldName}
      label="Personnummer"
      variant={props.ssnField.variant as VariantType}
      feedback={props.ssnField.feedback}
      value={props.ssnField.value && parseInt(props.ssnField.value, 10) >= 0 ? props.ssnField.value : ''}
      onChange={(e: { target: { value: string } }) =>
        props.updateSsn({
          ...props.ssnField,
          value: e.target.value,
        })
      }
      onBlur={validateAndUpdateSsn}
    />
  )
}
